import styled from "styled-components";
import { TextField } from "../";
export const TextArea = styled(TextField).attrs({
  as: "textarea"
})`
  background-color: ${props => props.disabled ? props.theme.input.disabled.backgroundColor : props.theme.input.backgroundColor};
  width: 100%;
  min-height: 160px;
  resize: none;
  ${props => props.error && `background-color: ${props.theme.input.error.backgroundColor};`};
`;